import { createSelector } from "reselect";
import { MAPS } from "../../Helpers/maps"

export const getMonsters = state => state.monsters;


// -------------------------------------------------------
// ------------------------HERO---------------------------
// -------------------------------------------------------

export const getHero = state => state.hero;

export const getHeroName = createSelector(
    getHero,
    (hero) => hero.name
);

export const getHeroPosition = createSelector(
    getHero,
    (hero) => hero.position
);

export const getHeroXP = createSelector(
    getHero,
    (hero) => hero.xp
);

export const getHeroStats = createSelector(
    getHero,
    (hero) => hero.stats
);

export const getHeroMana = createSelector(
    getHeroStats,
    (stats) => stats?.mana || 0
);

export const getHeroMaxMana = createSelector(
    getHeroStats,
    (stats) => stats?.maxMana || 0
);

export const getHeroManaPercentage = createSelector(
    getHeroMana,
    getHeroMaxMana,
    (mana, maxMana) => maxMana > 0 ? (mana / maxMana) * 100 : 0
);

export const getHeroLevel = createSelector(
    getHero,
    (hero) => hero.level
);

export const getHeroInventory = createSelector(
    getHero,
    (hero) => hero.inventory
);

export const getHeroGold = createSelector(
    getHero,
    (hero) => hero.gold
);

// -------------------------------------------------------
// ----------------------GAMEDATA-------------------------
// -------------------------------------------------------

export const getGameData = state => state.gameData;

export const getGameState = createSelector(
    getGameData,
    (gameData) => gameData.gameState 
);

export const getFightData = createSelector(
    getGameData,
    (gameData) => gameData.fightData 
);

export const getEventData = createSelector(
    getGameData,
    (gameData) => gameData.eventData 
);

export const getFightDataMonsters = createSelector(
    getFightData,
    (fightData) => fightData.monsters
);

export const getFightDataEndFightData = createSelector(
    getFightData,
    (fightData) => fightData.endFightData
);

export const getCurrentMonstersIndex = createSelector(
    getFightData,
    (fightData) => fightData.currentMonstersIndex
);

export const getDisplayModal = createSelector(
    getGameData,
    (gameData) => gameData.displayModal
);

export const getDisplayModalData = createSelector(
    getDisplayModal,
    (displayModal) => displayModal.data
);

// -------------------------------------------------------
// ------------------------MAP----------------------------
// -------------------------------------------------------

export const getMap = createSelector(
    getHeroPosition,
    (position) => MAPS[position.mapId]
);

export const getMapZones = createSelector(
    getMap,
    (map) => map.zones
);

export const getMapZoneByHeroPosition = createSelector(
    [getMapZones, getHeroPosition],
    (zones, position) => (zones?.["map" + position?.x + position?.y]) || null
);

// -------------------------------------------------------
// ------------------------USER---------------------------
// -------------------------------------------------------

export const getUser = state => state.user;
